import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Mapeamento de rotas para títulos
const routeTitles: { [key: string]: string } = {
  '/login': 'Login - WMS CenterSport',
  '/configurar-senha': 'Configurar Senha - WMS CenterSport',
  '/dashboard': 'Dashboard - WMS CenterSport',
  '/consulta': 'Consulta - WMS CenterSport',
  '/localizacao': 'Localização - WMS CenterSport',
  '/localizacao/criar': 'Criar Localização - WMS CenterSport',
  '/armazem': 'Armazém - WMS CenterSport',
  '/criar-armazem': 'Criar Armazém - WMS CenterSport',
  '/tipo-localizacao': 'Tipo de Localização - WMS CenterSport',
  '/tipo-localizacao/criar': 'Criar Tipo de Localização - WMS CenterSport',
  '/produto': 'Produto - WMS CenterSport',
  '/produto/criar': 'Criar Produto - WMS CenterSport',
  '/movimentacao': 'Movimentação - WMS CenterSport',
  '/separacao': 'Separação - WMS CenterSport',
  '/ocorrencia': 'Ocorrência - WMS CenterSport',
  '/criar-ocorrencia': 'Nova Ocorrência - WMS CenterSport',
  '/auditoria': 'Auditoria - WMS CenterSport',
  '/relatorio': 'Relatório - WMS CenterSport',
  '/historico-movimentacao': 'Histórico de Movimentação - WMS CenterSport',
  '/conferencia-localizacao': 'Conferência de Localização - WMS CenterSport',
  '/balanco': 'Balanço - WMS CenterSport',
  '/balanco/:id': 'Detalhes do Balanço - WMS CenterSport',
  // #1857: fora do menu, o título não vem mais da Sidebar
  '/oms/coleta-reposicao': 'Coleta de Reposição - WMS CenterSport',
  '/oms/full/:fullId/rastreio': 'Rastreio do Full - WMS CenterSport',
  '/usuario': 'Usuários - WMS CenterSport',
  '/criar-usuario': 'Criar Usuário - WMS CenterSport',
  '/perfil-usuario': 'Perfil de Usuário - WMS CenterSport',
  '/perfil-usuario/criar': 'Criar Perfil de Usuário - WMS CenterSport',
  '/perfil-usuario/editar': 'Editar Perfil de Usuário - WMS CenterSport',
  '/perfil-usuario/visualizar': 'Visualizar Perfil de Usuário - WMS CenterSport',
  '/permissoes-extras': 'Permissões Extras - WMS CenterSport',
  '/parametros': 'Parâmetros Configuráveis - WMS CenterSport',
  '/admin-central': 'Painel Admin - WMS CenterSport',
  '/admin-central/unidades': 'Unidades - WMS CenterSport',
  '/admin-central/usuarios': 'Usuários Central - WMS CenterSport',
  '/admin-central/perfis/:slug': 'Perfis - WMS CenterSport',
  '/admin-central/integracoes/:slug': 'Integrações - WMS CenterSport',
};

// Função para extrair título baseado na rota
const getTitleFromRoute = (pathname: string): string => {
  // Verificar se é uma rota exata
  if (routeTitles[pathname]) {
    return routeTitles[pathname];
  }

  // Verificar rotas dinâmicas (com parâmetros)
  for (const route in routeTitles) {
    if (route.includes(":")) {
      // Converter rota dinâmica em regex
      const routePattern = route.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${routePattern}$`);
      if (regex.test(pathname)) {
        return routeTitles[route];
      }
    }
  }

  // Título padrão se não encontrar correspondência
  return "WMS CenterSport";
};

export const usePageTitle = (customTitle?: string) => {
  const location = useLocation();

  useEffect(() => {
    const title = customTitle || getTitleFromRoute(location.pathname);
    document.title = title;
  }, [location.pathname, customTitle]);

  return {
    setTitle: (title: string) => {
      document.title = title;
    },
  };
};

export default usePageTitle;
